const VARIANTS = new Set([
  'section',
  'subtle',
  'nested',
  'action',
  'destructive',
]);

export default function ApplicationSurface({
  as: Element = 'section',
  variant = 'section',
  elevation = 'none',
  ariaLabelledby,
  className = '',
  children,
  ...rest
}) {
  if (!VARIANTS.has(variant)) {
    throw new Error(`Unsupported ApplicationSurface variant: ${variant}`);
  }

  if (!['none', 'raised'].includes(elevation)) {
    throw new Error(
      `Unsupported ApplicationSurface elevation: ${elevation}`
    );
  }

  const classes = [
    'av-app-surface',
    `av-app-surface--${variant}`,
    elevation === 'raised' ? 'av-app-surface--raised' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Element
      aria-labelledby={ariaLabelledby}
      className={classes}
      {...rest}
    >
      {children}
    </Element>
  );
}
